import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, withCtx as _withCtx, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import SogCardActionButton from "@/shared/ui/SogCardActionButton.vue";
import SogCard from "@/shared/ui/SogCard.vue";
import ExportBlankFormComponent from "@/modules/ShoppingCart/components/ExportBlankFormComponent.vue";
import SogCardActions from "@/shared/ui/SogCardActions.vue";
import SogCardContent from "@/shared/ui/SogCardContent.vue";
import {useShoppingCartStore} from "@/modules/ShoppingCart/store";
import {storeToRefs} from "pinia";
import {ref} from "vue";
import {fillNumberWithZeros} from "@/shared/utils/NumberUtils";
import notificationService from "@/shared/services/NotificationService";


export default /*@__PURE__*/_defineComponent({
  __name: 'ExportBlankComponent',
  setup(__props) {


const _shoppingCartStore = useShoppingCartStore();
const {currentItem: _current} = storeToRefs(_shoppingCartStore);
const _exportBlankForm = ref<InstanceType<typeof ExportBlankFormComponent> | null>(null);

async function onAddExportBlanks() {
  if(!_exportBlankForm.value)
    return
  const t_result = _exportBlankForm.value.getResults();
  if (_current.value.shoppingCartItem.productPrice?.productTypeId === "ExportBlank") {
    _current.value.shoppingCartItem.count = t_result.count;
    _current.value.shoppingCartItem.digitCount = t_result.digitCount;
    _current.value.shoppingCartItem.prefix = t_result.prefix;
    _current.value.shoppingCartItem.startNumber = t_result.startNumber;
    _current.value.shoppingCartItem.insuranceExportBlanks.length = 0;

    await _shoppingCartStore.addItem();
    return;
  }
  else if (_current.value.shoppingCartItem.productPrice?.productTypeId === "Zoll") {
    const t_start = t_result.prefix + fillNumberWithZeros(t_result.startNumber, t_result.digitCount)
    const t_end = t_result.prefix + fillNumberWithZeros((t_result.startNumber + t_result.count - 1), t_result.digitCount)

    const t_array = _shoppingCartStore.currentShoppingCart.storeExportBlank.filter(t => t.blankNumber && t.blankNumber >= t_start && t.blankNumber <= t_end)

    if (t_array.length !== t_result.count) {
      notificationService.error("Nicht alle Karten sind in Bestand");
      return
    }
    t_array.forEach(t => {
      _shoppingCartStore.addInsuranceExportBlank(t)
    });

    console.log(_shoppingCartStore.currentShoppingCart)

    await _shoppingCartStore.addStoreExportBlanks();
  }
}

async function onStoreExportBlank() {
  await _shoppingCartStore.navigate("storeexportblank")
  return;
}



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(SogCard, null, {
    default: _withCtx(() => [
      _createVNode(SogCardActions, { "is-toolbar": true }, {
        default: _withCtx(() => [
          _createVNode(SogCardActionButton, {
            "mdi-icon": "mdi-cart-arrow-down",
            tooltip: "In den Einkaufswagen legen",
            onClick: onAddExportBlanks
          }),
          _createVNode(SogCardActionButton, {
            "mdi-icon": "mdi-list-box",
            tooltip: "Liste",
            onClick: onStoreExportBlank
          })
        ]),
        _: 1
      }),
      _createVNode(SogCardContent, null, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_unref(_current).shoppingCartItem.productPrice?.productTypeId) + " ", 1),
          _createVNode(ExportBlankFormComponent, {
            ref_key: "_exportBlankForm",
            ref: _exportBlankForm,
            count: _unref(_shoppingCartStore).currentShoppingCart.deliveryCount
          }, null, 8, ["count"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})